enum WorkspaceProjectAssetRegistryStatus {
  draft = 'draft',
  reserved = 'reserved',
  pending = 'pending',
  sold = 'sold',
  deleted = 'deleted',
}

export default WorkspaceProjectAssetRegistryStatus
